import axios from "axios";
import { APP_CONFIG } from "../config/appConfig";

const BASE_URL = APP_CONFIG.BASE_API;

/* ================= AUTH / REGISTER ================= */

export const registerCandidate = (data) => {
  return axios.post(`${BASE_URL}/candidate/candidateRegisterweb`, data);
};

/* ================= MASTER DATA ================= */

export const getTimeZones = () => {
  return axios.get(`${BASE_URL}/candidate/getTimeZones`);
};

export const getCountryCodes = () => {
  return axios.get(`${BASE_URL}/candidate/countryTelephoneCode`);
};

export const getStatesByCountry = (params = {}) => {
  const queryParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      queryParams.append(key, params[key]);
    }
  });
  const queryString = queryParams.toString();
  const url = queryString
    ? `${BASE_URL}/candidate/getStates?${queryString}`
    : `${BASE_URL}/candidate/getStates`;
  return axios.get(url);
};

export const getTaxRate = (params = {}) => {
  const queryParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      queryParams.append(key, params[key]);
    }
  });
  const queryString = queryParams.toString();
  const url = queryString
    ? `${BASE_URL}/candidate/getTaxRate?${queryString}`
    : `${BASE_URL}/candidate/getTaxRate`;
  return axios.get(url);
};
export const CreatePayments = (data) => {
  return axios.post(`${BASE_URL}/candidate/createAuthOnlyOrder`, data);
};
export const createRazorpayAutoPay = (data) => {
  return axios.post(`${BASE_URL}/candidate/createRazorpayAutoPay`, data);
};
export const verifyRazorpayAutoPay = (data) => {
  return axios.post(`${BASE_URL}/candidate/verifyRazorpayAutoPay`, data);
};
export const getPaymentKeys = () => {
  return axios.post(`${BASE_URL}/candidate/getKeys`);
};

export const getApplicationMode = () => {
  return axios.get(`${BASE_URL}/candidate/applicationMode`);
};

export const getSubjects = (params = {}) => {
  const queryParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    if (
      params[key] !== undefined &&
      params[key] !== null &&
      params[key] !== ""
    ) {
      queryParams.append(key, params[key]);
    }
  });
  const queryString = queryParams.toString();
  const url = queryString
    ? `${BASE_URL}/candidate/getCandidateSubjects?${queryString}`
    : `${BASE_URL}/candidate/getCandidateSubjects`;
  return axios.get(url);
};

/* ================= PAYMENT ================= */

export const addPaymentInfo = (cuserid, data) => {
  return axios.post(`${BASE_URL}/candidate/addPaymentInfo/${cuserid}`, data);
};

/* ================= LOCATION ================= */

/**
 * Returns location data normalized so callers can use:
 * - data.country  → ISO2 country code
 * - data.timezone → IANA timezone string
 */
export const getUserLocation = () => {
  const locationURL =
    process.env.REACT_APP_LOCATION_IP || "https://ipapi.co/json/";

  return axios.get(locationURL).then((response) => {
    const raw = response.data || {};
    const country =
      raw.countryCode ||
      raw.country_code ||
      (typeof raw.country === "string" && raw.country.length <= 3
        ? raw.country
        : null);
    const timezone =
      raw.timezone ||
      (typeof raw.time_zone === "string" ? raw.time_zone : raw.time_zone?.id) ||
      null;

    return {
      ...response,
      data: {
        ...raw,
        country,
        timezone,
      },
    };
  });
};


/* ================= EXISTING USER CHECK ================= */

export const isCandidateAlreadyExists = (data) => {
  return axios.post(`${BASE_URL}/candidate/isCandidateAlreadyExists`, data);
};


